module.exports = __webpack_public_path__ + "static/do-2468708c7155a1936c4173314d7b8e16.svg";